import { createRegisteredContext } from 'react-singleton-context';
var ContextTest = createRegisteredContext('ContextTest', {
  pkg: 'No package set'
});
export default ContextTest;